module.exports = __webpack_public_path__ + "88433c89e4bd37986b74a305fdb58f7c.png";